var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip-wrap"},[_vm._v(" 注：户型图、VR、总平图、周边配套等信息均是对本项目所做的示意表现，仅供参考示意，实际情况以商品房买卖合同为准。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }